import React from "react";
import PublicLayout from "../../../layouts/user/PublicLayout";
import BeritaPopuler from "../../../components/user/posts/BeritaPopuler";
import CardSambutan from "../../../components/user/sambutan/CardSambutan";

function Sambutan() {
	return (
		<PublicLayout
			title="Sambutan"
			subtitle="Sambutan Kepala Kantor Wilayah Kemenag DIY"
		>
			<div className="flex flex-col lg:flex-row gap-8">
				<div className="w-full lg:w-[68%]">
					<CardSambutan />
				</div>
				<div className="w-full lg:w-[30%]">
					<BeritaPopuler />
				</div>
			</div>
		</PublicLayout>
	);
}

export default Sambutan;
